import {Injectable} from '@angular/core';
import {UserInteractor} from '../../interactors/user.interactor';
import {Keys, StorageService} from '../../service/storage.service';
import {LoanApplicationFlowStep} from './loan-application-flow.step';

@Injectable()
export class PanVerificationStep extends LoanApplicationFlowStep {
    private readonly userInteractor: UserInteractor;
    private readonly storageService: StorageService;

    constructor(userInteractor: UserInteractor, storageService: StorageService) {
        super();
        this.userInteractor = userInteractor;
        this.storageService = storageService;
    }

    async isComplete(): Promise<boolean> {
        const isUserRegistered = !!await this.userInteractor.getUserId();
        const isPanVerified = !!await this.storageService.getObjectFromSession(Keys.PHONE_VERIFICATION_REQUEST_TOKEN);
        return isUserRegistered || isPanVerified;
    }

    url(): string {
        return this.createBorrowerFlowUrl('pan-verification');
    }

    description(): string {
        return 'So that we can identify you';
    }

    displayName(): string {
        return 'PAN Verification';
    }
}